import commonScripts from './common';
import stickyHeader from './partials/sticky_header';
import listingApp from './partials/listing';
import carousel from './partials/carousel';
import getOffset from './partials/helpers/get_offset';

commonScripts();
stickyHeader();
listingApp();

carousel('.featured_entries__carousel');

window.onload = () => {
	if (window.location.href.indexOf('?video=on') > -1) {
		const listingOffset = getOffset(document.getElementById('listing'));
		const headerOffset = document.querySelector('.header').offsetHeight + 20;

		window.scroll(0, listingOffset - headerOffset);
	}
};



// WEBPACK FOOTER //
// ./assets/js/index.js